import React from 'react';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';

import { faPlus, faTag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { AclService } from '@service/acl'

import 'react-vertical-timeline-component/style.min.css';


class VerticalTimelineComponent extends React.Component {

    render() {

        const external = '#5e540f';
        const ombudsman = '#0f335e';
        const closed = '#5e0f0f';

        return (

            <VerticalTimeline layout='1-column-left'>
                {
                    this.props.data.map((row) => 

                        <VerticalTimelineElement
                            className="vertical-timeline-element--work"
                            iconStyle={
                                {
                                    background: row.closed === true ? closed : (row.user.position.id === 2 ? ombudsman : external), 
                                    color: '#fff'
                                }
                            }
                            icon={<FontAwesomeIcon icon={ faTag } />}
                            visible={true}
                            date={`${row.user.name} - ${row.created_at}`}
                        >
                            <p className='mt-0' dangerouslySetInnerHTML={{ __html: row.description }} />
                        </VerticalTimelineElement>

                    )
                }
            </VerticalTimeline>

        )
    }

}

export default VerticalTimelineComponent;